import { getCapitalizeMonth, getDayOfMonth } from './';

export const getDayOfMonthTitle = (date: Date | string): string => {
    const monthDay = getDayOfMonth(date);

    return monthDay === 1 ? getCapitalizeMonth(date) : String(monthDay);
};
